import React from 'react';
import { FadeIn } from './FadeIn';
import { Activity } from 'lucide-react';
export function Mechanism() {
  return <section className="py-24 md:py-32 bg-gradient-to-b from-[#111836] to-[#1A2352] relative border-y border-white/5 overflow-hidden" data-id="element-154">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#F5D0A9]/5 via-transparent to-transparent opacity-70" data-id="element-155" />

      <div className="container mx-auto px-6 max-w-4xl relative z-10" data-id="element-156">
        <FadeIn data-id="element-157">
          <div className="text-center mb-16" data-id="element-158">
            <span className="text-[#F2A68D] font-medium tracking-widest uppercase text-sm mb-6 block" data-id="element-159">
              The Unique Mechanism
            </span>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-[#F5D0A9]" data-id="element-160">
              The "Core Temp Reset" Protocol
            </h2>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-161">
          <div className="bg-[#0B1029]/60 backdrop-blur-md p-8 md:p-12 rounded-3xl border border-[#F5D0A9]/20 shadow-[0_0_50px_rgba(245,208,169,0.05)]" data-id="element-162">
            <p className="text-xl md:text-2xl text-slate-200 leading-relaxed mb-10 font-light text-center" data-id="element-163">
              Instead of trying to "force" sleep with sedation, this method uses
              targeted thermal and biological triggers to manually lower your
              core body temperature and suppress the midnight cortisol dump.
            </p>
            <div className="flex flex-col md:flex-row items-center gap-6 text-[#F5D0A9] bg-[#F5D0A9]/10 p-8 rounded-2xl border border-[#F5D0A9]/10" data-id="element-164">
              <div className="bg-[#F5D0A9]/20 p-4 rounded-full shrink-0" data-id="element-165">
                <Activity className="w-8 h-8" data-id="element-166" />
              </div>
              <p className="text-lg md:text-xl font-medium leading-relaxed text-center md:text-left" data-id="element-167">
                By syncing your light exposure and using the "Handshake Method,"
                we tell your brain that the "fire alarm" is a false positive.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}